import styled from 'styled-components';
import Icon from '@nubank/nuds-web/components/Icon/Icon';

import { themeSpace } from 'styles/themeUtils';

const AdvantagesListItemBullet = styled(Icon)`
  flex-shrink: 0;
  margin-right: ${themeSpace(1)};
`;

AdvantagesListItemBullet.displayName = 'AdvantagesListItemBullet';

export default AdvantagesListItemBullet;
